<template>
  <div class="scheduler" v-loading="loading" @scroll="onscroll()">

    loading - {{ loading }}
    <the-new-user-dialog
        :visible="visibleDialogNewUser"
        @close="visibleDialogNewUser = false"
        @created="createdUser"/>

    <div class="scheduler-bar">
      <div class="title-bar">
        <h1 class="title-bar__title">Бронирование</h1>
        <date-picker @change="changeDate" v-model="filterForm.date"></date-picker>
      </div>

      <div class="panel">
        <div class="panel__left">
          <div class="filter">
            <div class="filter__left field">
              <el-select
                  @change="changeDepartment()"
                  class="field__select el-mini"
                  v-model="filterForm.departmentId"
                  placeholder="Название центра"
                  name="department"
                  type=""
              >
                <el-option
                    v-for="item in departmentList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>

          </div>

        </div>
        <div class="panel__right">
          <el-button icon="el-icon-refresh-right" @click="changeDepartment(true)"></el-button>
          <el-button type="default" @click="addClient">Добавить клиента</el-button>
          <el-button type="primary" @click="openFindClientModal">Добавить бронь</el-button>
        </div>
      </div>

    </div>

    <scheduler
        v-if="scheduleData"
        :schedule-data="scheduleData.procedure"
        :date="scheduleData.day"
        :setting="setting"
        :departmentId="filterForm.departmentId"
        @row-click-event="rowClickEvent"
        @date-click-event="dateClickEvent"
        @click-event="clickEvent"
        @add-event="addEvent"
        @move-event="moveEvent"
        @edit-event="editEvent"
        @delete-event="deleteEvent"
        ref="scheduler"
    ></scheduler>


    <div class="hints">
      <div class="hint-item prompt">
        <div class="prompt__square prompt__square_end"></div>
        <span class="prompt__title">- завершено</span>
      </div>

      <div class="hint-item prompt">
        <div class="prompt__square prompt__square_process"></div>
        <span class="prompt__title">- в процессе</span>
      </div>

      <div class="hint-item prompt">
        <div class="prompt__square prompt__square_not-started"></div>
        <span class="prompt__title">- не начаты</span>
      </div>


    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/ganttCalendar/DatePicker"
import Scheduler from "@/components/ganttCalendar/Scheduler"
import {mapActions, mapGetters} from "vuex"

import TheNewUserDialog from "@/components/dialog/TheNewUserDialog.vue"

export default {
  name: "ganttCalendar",
  data() {
    return {

      departmentList: {
        options: [],
      },
      filterForm: {
        text: null,
        departmentId: [],
        date: new Date(),
      },
      setting: {
        unit: 5, // Minutes
        borderW: 1, // Px
        dateDivH: 50, // Px
        timeDivH: 60, // Px
        unitDivW: 28, // Px
        titleDivW: 20, // Percent
        rowH: 226, // Px
      },
      visibleDialogNewUser: false,
    }
  },
  components: {
    Scheduler,
    TheNewUserDialog,
    DatePicker
  },
  created() {
    this.getDepartments();
  },
  mounted() {
    if (this.$route.params.date) this.filterForm.date = this.$route.params.date

    this.changeDate(false)
  },
  computed: {
    ...mapGetters("appointment", {
      scheduleData: "appointment",
      loading: "loadAppointment",
    }),
    currentDate() {
      return this.$root.dateDefault(this.filterForm.date);
    },
  },
  methods: {
    ...mapActions({
      openFindClientModal: "appointment/OPEN_MODAL_FIND_CLIENT",
      openModalAppointment: "appointment/OPEN_MODAL_APPOINTMENT",
      setDate: "appointment/SET_CURRENT_DATE",
      setCurrentUser: "appointment/SET_CURRENT_USER",
      setDepartment: "appointment/SET_CURRENT_DEPARTMENT",
      getAppointment: "appointment/GET_APPOINTMENT",
    }),
    changeDepartment(update) {
      if (!update)
        this.setDepartment(
            this.departmentList[
                this.departmentList.findIndex(
                    (e) => e.id === this.filterForm.departmentId
                )
                ]
        );

      this.getAppointment();
    },
    onscroll() {

    },
    createdUser (user) {
      console.log('user', user)

      this.setCurrentUser(user)
      this.openModalAppointment()
    },
    addClient() {
      this.visibleDialogNewUser = true
    },
    changeDate(router = true) {

      if(router) this.$router.push({name: "cpanel.schedule", params: {date: this.$root.dateBack(router)}})

      this.setDate(this.$root.dateBack(router))
      this.getAppointment()
    },
    getDepartments() {
      this.$api.session
          .getDepartments("full")
          .then((response) => {
            this.departmentList = response.data

            this.filterForm.departmentId = response.data[0].id
            this.changeDepartment();
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
          });
    },
    dateClickEvent(date) {

      console.log("DateClickEvent Date:" + date);
    },
    rowClickEvent(rowIndex, text) {

      console.log("RowClickEvent RowIndex:" + rowIndex);
      console.log("RowClickEvent RowTitle:" + text);
    },
    clickEvent(startDate, endDate, text, other) {

      console.log("ClickEvent StartDate:" + startDate);
      console.log("ClickEvent EndDate:" + endDate);
      console.log("ClickEvent ContentText:" + text);
      if (other) {
        console.log("OtherData:", other);
      }
    },
    addEvent(rowIndex, startDate, endDate) {
      console.log("RowIndex:" + rowIndex);
      console.log("StartDate:" + startDate);
      console.log("EndDate:" + endDate);
    },
    moveEvent(status, newStartDate, newEndDate) {

      if (status === 1) {
        console.log("NewStartDate:" + newStartDate);
        console.log("NewEndDate:1" + newEndDate);
      } else if (status === 2) {
        this.$notify.warning({
          title: "Не получилось передвинуть",
          message: "Поле занято!",
        });
      } else {
        console.log("Not businessDay, can't move.");
      }
    },
    editEvent(newStartDate, newEndDate) {
      console.log("EditEvent NewStartDate:" + newStartDate);
      console.log("EditEvent NewEndDate:" + newEndDate);
    },
    deleteEvent(row, index) {
      console.log("DeleteEvent Row, index:", row, index);
    }
  },
};
</script>

<style scoped lang="scss">
.scheduler {
  margin: 0 auto;

  @media only screen and (max-width: 850px) {
    & {
      margin: 70px 25px 150px 25px;

    }
  }

  /deep/ .card {
    padding: 10px 0 0 0;

    .card__title {
      padding: 10px;
      margin: 0;
    }
  }


  &__sub-title {
    margin: 4px 0 16px 0;
    padding: 0;

    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #8e8e93;
  }
}


.scheduler-bar {
  margin: 70px 70px 17px 120px;

  position: sticky;
  top: 50px;
  z-index: 2000;

  box-sizing: border-box;

  padding: 10px 0;
}

.title-bar {
  width: max-content;

  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;

    color: #000;
    margin:  0;
  }

}

.scheduler-card {
  border: 1px solid #efeff4;
  margin: 20px 0 10px 0;
}

.hints {
  margin: 25px  0 0 122px;

  display: flex;
  align-items: center;
  color: #8e8e93;
  font-size: 13px;
  line-height: 16px;
}

.prompt {
  display: flex;
  align-items: center;
  margin-right: 10px;

  &__square {
    margin-right: 5px;
  }

  &__title {
    font-size: 13px;
    line-height: 16px;


    color: #111111;

  }

  &__square {
    width: 16px;
    height: 16px;
    margin-left: 5px;
    border-radius: 2px;


    &_not-started {
      background-color: #FFD791 !important;
    }
    &_end {
      background-color: #43D3B3 !important;
    }
    &_process {
      background-color: #EE4266;
    }
  }
}



/deep/ .el-loading-mask {
  z-index: 1999;
}

.panel {
  margin-top: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 850px) {
    & {
      //display: block;
    }
  }

  &__left {
    .filter {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &__left {
        display: flex;
        align-items: center;
      }

      &__left {
        display: flex;
        align-items: center;
      }

      .field {


        &__select {
          margin-right: 16px;
          width: 150px;

          @media only screen and (max-width: 850px) {
            & {
              width: 90px;
            }
          }
        }

        &__date {
          width: 130px;
        }
      }

    }

  }

  &__right {
    display: flex;
  }
}


</style>

